"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectWithoutProperties = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var formatters_1 = require("../formatters");

var subscriptions_1 = require("../subscriptions");

var utils_1 = require("../utils");

var tx_1 = require("./tx");

var tx_deploy_1 = require("./tx-deploy");
/**
 * Should be called to create new contract instance
 *
 * @method Contract
 * @constructor
 * @param {Array} jsonInterface
 * @param {String} address
 * @param {Object} options
 */


var Contract = /*#__PURE__*/function () {
  function Contract(eth, contractAbi, address) {
    var defaultOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Contract);

    this.eth = eth;
    this.contractAbi = contractAbi;
    this.address = address;
    this.defaultOptions = defaultOptions;
    this.linkTable = {};
    this.methods = this.buildMethods();
    this.events = this.buildEvents();
  }

  _createClass(Contract, [{
    key: "link",
    value: function link(name, address) {
      this.linkTable[name] = address;
    }
  }, {
    key: "deployBytecode",
    value: function deployBytecode(data) {
      var _this = this;

      var linkedData = Object.entries(this.linkTable).reduce(function (data, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            address = _ref2[1];

        return data.replace(new RegExp("_+".concat(name, "_+"), 'gi'), address.toString().slice(2).toLowerCase());
      }, data);

      if (linkedData.includes('_')) {
        throw new Error('Bytecode has not been fully linked.');
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return new tx_deploy_1.TxDeploy(this.eth, this.contractAbi.ctor, this.contractAbi, utils_1.hexToBuffer(linkedData), args, this.defaultOptions, function (addr) {
        return _this.address = addr;
      });
    }
  }, {
    key: "once",
    value: function once(event, options, callback) {
      this.on(event, options, function (err, res, sub) {
        sub.unsubscribe();
        callback(err, res, sub);
      });
    }
  }, {
    key: "getPastEvents",
    value: function () {
      var _getPastEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var _this2 = this;

        var options,
            logOptions,
            result,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                logOptions = this.getLogOptions(event, options);
                _context.next = 4;
                return this.eth.getPastLogs(logOptions);

              case 4:
                result = _context.sent;
                return _context.abrupt("return", result.map(function (log) {
                  return _this2.contractAbi.decodeEvent(log);
                }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPastEvents(_x) {
        return _getPastEvents.apply(this, arguments);
      }

      return getPastEvents;
    }()
  }, {
    key: "on",
    value: function on(event) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var logOptions = this.getLogOptions(event, options);

      var fromBlock = logOptions.fromBlock,
          subLogOptions = _objectWithoutProperties(logOptions, ["fromBlock"]);

      var params = [formatters_1.toRawLogRequest(subLogOptions)];
      var subscription = new subscriptions_1.Subscription('eth', 'logs', params, this.eth.provider, function (result, sub) {
        var output = formatters_1.fromRawLogResponse(result);

        var eventLog = _this3.contractAbi.decodeEvent(output);

        sub.emit(output.removed ? 'changed' : 'data', eventLog);

        if (callback) {
          callback(undefined, eventLog, sub);
        }
      }, false);
      subscription.on('error', function (err) {
        if (callback) {
          callback(err, undefined, subscription);
        }
      });

      if (fromBlock !== undefined) {
        this.eth.getPastLogs(logOptions).then(function (logs) {
          logs.forEach(function (result) {
            var output = _this3.contractAbi.decodeEvent(result);

            subscription.emit('data', output);
          });
          subscription.subscribe();
        }).catch(function (err) {
          subscription.emit('error', err);
        });
      } else {
        subscription.subscribe();
      }

      return subscription;
    }
  }, {
    key: "executorFactory",
    value: function executorFactory(functions) {
      var _this4 = this;

      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (!_this4.address) {
          throw new Error('No contract address.');
        }

        var firstMatchingOverload = functions.find(function (f) {
          return args.length === f.numArgs();
        });

        if (!firstMatchingOverload) {
          throw new Error("No matching method with ".concat(args.length, " arguments for ").concat(functions[0].name, "."));
        }

        return new tx_1.Tx(_this4.eth, firstMatchingOverload, _this4.contractAbi, _this4.address, args, _this4.defaultOptions);
      };
    }
  }, {
    key: "buildMethods",
    value: function buildMethods() {
      var _this5 = this;

      var methods = {};
      this.contractAbi.functions.forEach(function (f) {
        var executor = _this5.executorFactory([f]);

        methods[f.asString()] = executor;
        methods[f.signature] = executor;
      });
      var grouped = this.contractAbi.functions.reduce(function (acc, method) {
        var funcs = [].concat(_toConsumableArray(acc[method.name] || []), [method]);
        return _objectSpread({}, acc, _defineProperty({}, method.name, funcs));
      }, {});
      Object.entries(grouped).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            name = _ref4[0],
            funcs = _ref4[1];

        methods[name] = _this5.executorFactory(funcs);
      });
      return methods;
    }
  }, {
    key: "buildEvents",
    value: function buildEvents() {
      var _this6 = this;

      var events = {};
      this.contractAbi.events.forEach(function (e) {
        var event = _this6.on.bind(_this6, e.signature);

        if (!events[e.name]) {
          events[e.name] = event;
        }

        events[e.asString()] = event;
        events[e.signature] = event;
      });
      events.allEvents = this.on.bind(this, 'allevents');
      return events;
    }
  }, {
    key: "getLogOptions",
    value: function getLogOptions() {
      var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'allevents';
      var options = arguments.length > 1 ? arguments[1] : undefined;

      if (!this.address) {
        throw new Error('No contract address.');
      }

      if (eventName.toLowerCase() === 'allevents') {
        return _objectSpread({}, options, {
          address: this.address
        });
      }

      var event = this.contractAbi.events.find(function (e) {
        return e.name === eventName || e.signature === '0x' + eventName.replace('0x', '');
      });

      if (!event) {
        throw new Error("Event ".concat(eventName, " not found."));
      }

      return _objectSpread({}, options, {
        address: this.address,
        topics: event.getEventTopics(options.filter)
      });
    }
  }]);

  return Contract;
}();

exports.Contract = Contract;